module.exports = __webpack_public_path__ + "static/media/jamie-photo.a742c4ea.png";